module.exports = __webpack_public_path__ + "img/undraw_Team.85e801ff.svg";